import { Controller } from "@hotwired/stimulus"

// Type-to-narrow inside a menu that got too long to read.
//
// "See it as" listed every person in the tree - fine at eight, unusable at
// ninety-one, where the menu is taller than the window and the name you want is
// somewhere in the middle of it. Folding matches accents the way the rest of
// the app does (TextSearch server-side, _normalizeSearch in the chart), because
// a family with a Jérome in it is exactly where an accent-sensitive filter
// fails.
export default class extends Controller {
    static targets = ["input", "item", "empty"]

    connect() {
        this.filter()
    }

    filter() {
        let query = this._fold(this.hasInputTarget ? this.inputTarget.value : "")
        let shown = 0
        this.itemTargets.forEach((item) => {
            let match = !query || this._fold(item.dataset.menuFilterName || item.textContent).includes(query)
            item.hidden = !match
            if (match) shown += 1
        })
        if (this.hasEmptyTarget) this.emptyTarget.hidden = shown > 0
    }

    // Enter picks the only remaining name - the point of typing is usually that
    // you already know which one you want.
    keydown(event) {
        if (event.key !== "Enter") return

        let visible = this.itemTargets.filter((item) => !item.hidden)
        if (visible.length !== 1) return

        event.preventDefault()
        visible[0].click()
    }

    _fold(value) {
        return String(value || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim()
    }
}
